/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAnnouncementsRelevanceConfirmNotActualModel,
  IAnnouncementsRelevanceConfirmNotActualRequest,
  IMappers,
  IAnnouncementsRelevanceConfirmNotActualResponseError,
  TAnnouncementsRelevanceConfirmNotActualResponse,
} from './types';

const defaultConfig: TAnnouncementsRelevanceConfirmNotActualModel = {
  apiType: 'public',
  assertStatusCodes: [204, 400],
  method: 'GET',
  microserviceName: 'moderation-announcements-relevance',
  pathApi: '/v3/announcements-relevance/confirm-not-actual/',
  hostType: 'api',
} as TAnnouncementsRelevanceConfirmNotActualModel;

function createAnnouncementsRelevanceConfirmNotActualModel(
  parameters: IAnnouncementsRelevanceConfirmNotActualRequest,
): TAnnouncementsRelevanceConfirmNotActualModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAnnouncementsRelevanceConfirmNotActualOptions<TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAnnouncementsRelevanceConfirmNotActualRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse204, TResponse400>;
}

async function fetchAnnouncementsRelevanceConfirmNotActual<TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAnnouncementsRelevanceConfirmNotActualOptions<TResponse204, TResponse400>): Promise<
  TResponse204 | TResponse400 | TAnnouncementsRelevanceConfirmNotActualResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createAnnouncementsRelevanceConfirmNotActualModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as IAnnouncementsRelevanceConfirmNotActualResponseError);
    }
  }

  return { response, statusCode } as TAnnouncementsRelevanceConfirmNotActualResponse;
}

export {
  defaultConfig,
  createAnnouncementsRelevanceConfirmNotActualModel,
  fetchAnnouncementsRelevanceConfirmNotActual,
};
